import React from 'react';
import StarIcon from '../../atoms/star';
import RatingStat, { RatingStatProps } from '../../atoms/rating-stat';
import { useFormat } from 'helpers/hooks/useFormat';
import Link from 'next/link';

export interface RatingStatsProps {
  ratingCounts: RatingStatProps[];
  averageRatingLabel?: string;
  averageRating: number;
  countLabel?: string;
  countLabelLink?: {
    href: string;
    text: string;
  };
  className?: string;
}

const RatingStats: React.FC<RatingStatsProps> = ({
  ratingCounts,
  averageRating,
  averageRatingLabel,
  countLabel,
  countLabelLink,
  className = '',
}) => {
  const { formatMessage } = useFormat({ name: 'common' });

  return (
    <div
      className={`flex w-full flex-col gap-16 md:flex-row md:justify-between lg:flex-col lg:justify-normal ${className}`}
    >
      {/* Left: Average Rating */}
      <div className="flex min-w-[220px] flex-1 flex-col">
        <div className="flex gap-2">
          <p className="body-text-medium font-medium">
            {averageRatingLabel ?? formatMessage({ id: 'rating.averageLabel', defaultMessage: 'Average Rating' })}{' '}
            <span className="body-text-x-large ml-4 font-bold">{averageRating.toFixed(1)}</span>
          </p>
          <StarIcon variant="filled" size={24} className="justify-self-center" />
        </div>
        {countLabel && (
          <p className="body-text-small mt-4 font-medium text-text-tertiary">
            {countLabel}{' '}
            {countLabelLink && (
              <Link href={countLabelLink.href} className="text-text-tertiary underline">
                {countLabelLink.text}
              </Link>
            )}
          </p>
        )}
      </div>
      {/* Right: Rating Breakdown */}
      <div className="flex flex-1 flex-col gap-8">
        {ratingCounts.map((rating) => (
          <RatingStat key={rating.ratingValue} {...rating} />
        ))}
      </div>
    </div>
  );
};

export default RatingStats;
